export default __webpack_public_path__ + "static/media/effort-remois.e3d94df8.png";